import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StatementLoadingDialogComponent } from './statement-loading-dialog.component';

@NgModule({
    declarations: [StatementLoadingDialogComponent],
    imports: [CommonModule],
    exports: [StatementLoadingDialogComponent]
})
export class StatementLoadingDialogModule { }